import { render } from "./AppForbidden.vue?vue&type=template&id=d59b316a&scoped=true"
import script from "./AppForbidden.vue?vue&type=script&lang=js"
export * from "./AppForbidden.vue?vue&type=script&lang=js"

import "./AppForbidden.vue?vue&type=style&index=0&id=d59b316a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59b316a"]])

export default __exports__